import React, { useState, useEffect, useRef  } from 'react';
import { useLocation } from 'react-router-dom';
import './Detail.scss';
import common from '../../common'; 
import { FaDownload } from 'react-icons/fa';

import { useSelector , useDispatch } from 'react-redux';

import axios from 'axios';

const FingerprintJS = require('@fingerprintjs/fingerprintjs');

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Detail({ isLogin }) {
    const loginInfo = useSelector((state) => state.user.loginInfo);
    const loginName = loginInfo.name;

    const { useAlert, useConfirm, useModal, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pModal, ModalComponent } = useModal();
    const { pConfirm, ConfirmComponent} = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    // const targetIdx = queryParams.get('id');
    let targetIdx = queryParams.get('id');


    const [data , setData] = useState([]);
    const [files, setFiles] = useState([]);

    const [memberDepartChk, setMemberDepartChk] = useState(false);

    const [recruitChk, setRecruitChk] = useState(false);
    
    const [cateIdx, setCateIdx] = useState(0);

    const [commentPack, setCommentPack] = useState([]);


    let fetchDataUrl = `${API_BASE_URL}/naek_document/out/get_detail`; 
    let fetchDataParams = { targetIdx: targetIdx };
    const type = queryParams.get('type');
    const temporary_code = queryParams.get('temporary_code');
    const temporary_type = queryParams.get('temporary_type');
    if (type && type=='temporary_naek' && temporary_code) {
        targetIdx=90000000;
        fetchDataUrl = `${API_BASE_URL}/naek_document/out/get_detail_temporary`; 
        fetchDataParams = { targetIdx: targetIdx, targetCode: temporary_code };
    }

    const fetchData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(fetchDataUrl, fetchDataParams, {
                withCredentials: true
            });
            if (response.data.result === 't') {
                setData(response.data.data);
                setFiles(response.data.data.file);
                if(response.data.data.memberDepart===true){
                    setMemberDepartChk(true);
                }
                setCateIdx(response.data.data.cateIdx);
                if (type && type=='temporary_naek' && temporary_code && temporary_type && temporary_type=='naekmonthly') {
                    setCateIdx(271);
                }
                
                if(response.data.data.commentPack){
                    setCommentPack(response.data.data.commentPack);
                }
                
                if(response.data.data.recruit===true){
                    setRecruitChk(true);
                }

                const titEl = document.querySelector('.top_only_big_tit');
                if (titEl) {
                    titEl.textContent = response.data.data.documentCategoryName;
                }
                const titEl2 = document.querySelector('.mo_hd_page_tit');
                if (titEl2) {
                    titEl2.textContent = response.data.data.documentCategoryName;
                }

            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Fetch failed:', error);
            pAlert('실패함.');
        } finally {
            pLoadingOff();
        }
    };








    // 회원 전문분과위원회 --

    const [memberDepartEditStat , setMemberDepartEditStat] = useState(false);
    const memberDepartEditChk = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/naek_member_depart/in/chk_edit_possible`,
                { doc:targetIdx },
                { withCredentials: true }
            );
            if (response.data.result === 't' && response.data.msg===true) {
                setMemberDepartEditStat(true);
            } else {
                setMemberDepartEditStat(false);
            }
        } catch (error) {
            console.error('Fetch failed:', error);
            pAlert('실패함.');
        } finally {
            pLoadingOff();
        }
    };
    
    const gogoMdList = async () => {
        window.location.href = '/memberDepart?pageid='+cateIdx.toString();
    };
    const gogopage = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/naek_member_depart/in/chk_edit_possible`,
                { doc:targetIdx },
                { withCredentials: true }
            );
            if (response.data.result === 't' && response.data.msg===true) {
                window.location.href = response.data.data;
            }
        } catch (error) {
            console.error('Fetch failed:', error);
            pAlert('실패함.');
        } finally {
            pLoadingOff();
        }
    };

    const [MdCommentWriteStat , setMdCommentWriteStat] = useState(false);
    const memberDepartCommentWriteChk = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/naek_member_depart/in/chk_write_possible`,
                { pageid:cateIdx.toString() },
                { withCredentials: true }
            );

            if (response.data.result === 't' && response.data.msg===true) {
                setMdCommentWriteStat(true);
            } else {
                setMdCommentWriteStat(false);
            }
        } catch (error) {
            console.error('Fetch failed:', error);
            pAlert('실패함.');
        } finally {
            pLoadingOff();
        }
    };

    useEffect(() => {
        if(isLogin && memberDepartChk){
            memberDepartEditChk();
            memberDepartCommentWriteChk();
        }
    }, [memberDepartChk]);

    // useEffect(() => {
    //     if(recruitChk){
    //     }
    // }, [recruitChk]);
    const recEmailRef = useRef(null);
    const recNameRef = useRef(null);
    const recFileRef = useRef(null);
    const recCheckboxRef = useRef(null);
    const recHandleSubmit = async (e) => {
        e.preventDefault();
        if (!recruitChk) return;

        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const visitor_id = result.visitorId;
        const email = recEmailRef.current.value.trim();
        const name = recNameRef.current.value.trim();
        const file = recFileRef.current.files[0];
        const agreed = recCheckboxRef.current.checked;
        if (!agreed) {
            pAlert('개인정보 수집·이용 동의는 필수입니다.');
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
            pAlert('올바른 이메일을 입력해주세요.');
            return;
        }
        if (!name) {
            pAlert('이름을 입력해주세요.');
            return;
        }
        if (!file) {
            pAlert('첨부파일을 업로드해주세요.');
            return;
        }
        const allowedExtensions = ['pdf', 'doc', 'docx', 'hwp'];
        const fileExtension = file.name.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
            pAlert('허용된 파일 형식은 PDF, Word(doc/docx), HWP입니다.');
            return;
        }
        const submitData = async () => {
            try {
                pConfirm(
                    '확인',
                    <>
                        <div>제출 하시겠습니까?</div>
                    </>,
                    '400px',
                    'auto',
                    async () => {
                        try {
                            pLoadingOn();
                            const formData = new FormData();
                            formData.append('target_idx', targetIdx);
                            formData.append('visitor_id', visitor_id);
                            formData.append('email', email);
                            formData.append('name', name);
                            formData.append('file', file);

                            const response = await axios.post(`${API_BASE_URL}/naek_document/out/rec_submit`, formData, {
                                withCredentials: true,
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            });
                            pAlert(response.data.msg);
                            if (response.data.result === 't') {
                                recEmailRef.current.value = '';
                                recNameRef.current.value = '';
                                recFileRef.current.value = '';
                                recCheckboxRef.current.checked = false;
                            }
                        } catch (error) {
                            console.error('제출 실패:', error);
                        } finally {
                            pLoadingOff();
                        }
                    }
                );
            } catch (error) {
                console.error('Fetch failed:', error);
                pAlert('실패함.');
            } finally {
            }
        };
        submitData();
    };
    
    
    const [taVal, setTaVal] = useState("");
    const taRef = useRef(null);
    const taChange = (e) => {
        setTaVal(e.target.value);
        taRef.current.style.height = "auto";
        taRef.current.style.height = `${taRef.current.scrollHeight}px`;
    };

    const gogoComment = (e) => {
        pConfirm(
            '댓글 등록',
            <>
                <div>댓글을 등록 하시겠습니까?</div>
            </>,
            '400px',
            'auto',
            async () => {
                try {
                    pLoadingOn();
                    const response = await axios.post(`${API_BASE_URL}/naek_document/in/comment_insert`,
                        { targetIdx:targetIdx, contents:taVal }, {
                        withCredentials: true
                    });

                    if (response.data.result === 't') {
                        fetchData();
                        pAlert('댓글 등록이 완료되었습니다.');
                        setTaVal('');
                    } else {
                        pAlert(response.data.msg);
                    }
                } catch (error) {
                    console.error('Data fetching failed:', error);
                } finally {
                    pLoadingOff();
                }
            }
        );
    };
    const gogoCommentDel = (coIdx) => {
        pConfirm(
            '댓글 삭제',
            <>
                <div>댓글을 삭제 하시겠습니까?</div>
            </>,
            '400px',
            'auto',
            async () => {
                try {
                    pLoadingOn();
                    const response = await axios.post(`${API_BASE_URL}/naek_document/in/comment_status_update`,
                        { targetIdx:coIdx }, {
                        withCredentials: true
                    });

                    if (response.data.result === 't') {
                        // fetchData();
                        setCommentPack((prevComments) =>
                            prevComments.filter((comment) => comment.idx !== coIdx)
                        );
                        pAlert('댓글이 삭제되었습니다.');
                        setTaVal('');
                    } else {
                        pAlert(response.data.msg);
                    }
                } catch (error) {
                    console.error('Data fetching failed:', error);
                } finally {
                    pLoadingOff();
                }
            }
        );
    };
    
    // 회원 전문분과위원회 --

    




    









    useEffect(() => {
        fetchData();
    }, []);

    const handleFileDownload = async (file) => {
		if (file.isLocal) {
            pLoadingOn();
			const link = document.createElement('a');
			link.href = file.serverName;
			link.download = file.name;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
            pLoadingOff();
		} else {
			try {
				pLoadingOn();
				const response = await axios.post(`${API_BASE_URL}/naek_document/out/get_file`, {
                    idx: [file.idx],
                    serverName: file.serverName,
                    name: file.name
                }, {
                    withCredentials: true,
                    responseType: 'blob'  // 응답 타입을 blob으로 설정
                });

                if (response.status === 200) { // HTTP 응답 상태 코드가 200인 경우
                    const blob = response.data;
                    const downloadUrl = window.URL.createObjectURL(blob);

                    // Blob을 사용하여 파일 다운로드
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = file.name;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Blob URL을 해제
                    window.URL.revokeObjectURL(downloadUrl);
                } else {
                    pAlert('파일 다운로드에 실패했습니다.');
                }

			} catch (error) {
				pAlert(`파일다운에 실패했습니다. 다시 시도해 주세요.`);
			} finally {
				pLoadingOff();
			}
		}
	};

    function fileContent (){
        return (
            <div>
                {files.map((file, index) => (
                    <div key={index}>
                        <button
                            onClick={() => handleFileDownload(file)}
                            className='p_detail_file_txt'
                        >{file.name} <FaDownload /></button>
                    </div>
                ))}
            </div>
        );
    }
    

    return (
        <>
            <AlertComponent />
            <ConfirmComponent/>
            <LoadingComponent />
            <ModalComponent />
            <div className="components_wrap p_document_detail_wrap">
                <div className='p_detail_wrap'>
                    <div className='p_detail_header'>
                        <h1>{data.title}</h1>
                        <div className='p_detail_meta'>
                            {data.adminName && (
                                <span className='adminName'>{data.adminName}</span>
                            )}
                            <span className='date'>{data.createTime}</span>
                            <span className='views'><img src="/img/views.png" alt="views" />{data.view}</span>
                        </div>
                    </div>
                    {Array.isArray(data.file) && data.file.length > 0 ? (
                        <div className='p_detail_file_box'>
                            <button className='p_detail_file_down_btn' onClick={() => pModal('',fileContent,'auto','auto')}>
                                첨부파일({data.file.length})<i className='download_icon'></i>
                            </button>
                        </div>
                    ) : (
                        <div className='p_detail_file_box'>
                            {/* <span>해당 게시글은 첨부파일이 없습니다.</span> */}
                        </div>
                    )}
                    {/* 기타 내용 */}
                    {/* <div className={`p_detail_content p_detail_content_${cateIdx}`} dangerouslySetInnerHTML={{ __html: data.contents }} /> */}
                    {/* 한국공학한림원 창립 30주년 기념식 개최 안내 때문에 수정 */}
                    <div
                    className={`p_detail_content ${
                        targetIdx === '10950' ? "p_detail_content_271" : `p_detail_content_${cateIdx}`
                    }`}
                    dangerouslySetInnerHTML={{ __html: data.contents }}
                    />
                    {recruitChk && (
                        <>
                            <div className='docu_recruit_wrap cont_wrap'>
                                <div className='cont_tit_box'>
                                    <span>지원서 제출</span>
                                </div>
                                <span className='rec_info'>'한국공학한림원'(이하'기관'은)는 개인정보보호법등 관련법령에 따라 지원자의 개인정보보호를 매우 중요시하며, 지원자께서 안심하고 지원할 수 있도록 최선을 다하고 있습니다.</span>
                                <span className='rec_info'>정보주체로부터 개인정보를 수집함에 있어, 아래내용을 안내하고 있습니다. 정보주체가 되는 이용자께서는 아래 내용을 상세히 읽어보신 후에 동의여부를 결정하여 주시기 바랍니다.</span>
                                <div className='recruit_agree_box'>
                                    <p className='f_bold rec_agree_tit'>1. 수집하는 개인정보의 항목</p>
                                    <div className='rec_agr_item'>
                                        <li className='rec_fullw_tit'>우리 기관은 직원채용업무를 수행하기 위해 아래와 같은 개인정보를 수집하고 있습니다.</li>
                                        <li className='rec_fullw_tit bul_list'>수집항목</li>
                                        <li className='rec_fullw_tit bul_list_b_1'>입사지원 관련 사항 : 성명, 현주소, 주민등록지 주소, 사진, 전화번호, 휴대폰전화번호, 이메일, 보훈여부, 장애여부, 학력사항, 외국어사항, 자격사항, 병역사항, 경력사항, 자기소개사항, 가족사항(가족의 성명, 관계, 연령, 학력, 직업)</li>
                                        <li className='rec_fullw_tit bul_list'>수집방법 : 이력서 및 자기소개서 서류 작성</li>
                                    </div>
                                    
                                    <p className='f_bold rec_agree_tit'>2. 개인정보의 수집 및 이용목적</p>
                                    <div className='rec_agr_item'>
                                        <li className='rec_fullw_tit'>우리 기관은 지원자의 개인정보를 다음의 목적을 위해서만 활용합니다.</li>
                                        <li className='rec_fullw_tit bul_list'>입사지원서 접수</li>
                                        <li className='rec_fullw_tit bul_list'>선발전형의 기초자료</li>
                                        <li className='rec_fullw_tit bul_list'>어학 및 자격증의 검증</li>
                                        <li className='rec_fullw_tit bul_list'>채용관련 정보 안내(합격자 통보 등)</li>
                                    </div>
                                    
                                    <p className='f_bold rec_agree_tit'>3. 개인정보 보유 및 이용기간</p>
                                    <div className='rec_agr_item'>
                                        <li className='rec_fullw_tit'>개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.</li>
                                        <li className='rec_fullw_tit bul_list'>보존항목 : 입사지원데이터 및 증빙서류</li>
                                        <li className='rec_fullw_tit bul_list'>보존근거 : 입사지원 서류 보존 방침(내부규정)</li>
                                        <li className='rec_fullw_tit bul_list'>보존기간 : 2년 (기간경과 즉시 파기)</li>
                                    </div>
                                    
                                    <p className='f_bold rec_agree_tit'>4. 개인정보의 파기절차 및 방법</p>
                                    <div className='rec_agr_item'>
                                        <li className='rec_fullw_tit'>개인정보를 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</li>
                                        <li className='rec_fullw_tit bul_list'>파기절차</li>
                                        <li className='rec_fullw_tit bul_list_b_1'>지원자의 입력 정보는 내부 규정 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 명시된 보존 기간 동안 보관된 후 파기됩니다.</li>
                                        <li className='rec_fullw_tit bul_list'>파기방법</li>
                                        <li className='rec_fullw_tit bul_list_b_1'>전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
                                        <li className='rec_fullw_tit bul_list_b_1'>서류(종이)의 경우 분쇄합니다.</li>
                                    </div>
                                    
                                    <p className='f_bold rec_agree_tit'>5. 개인정보 처리 위탁에 관한 안내</p>
                                    <div className='rec_agr_item'>
                                        <li className='rec_fullw_tit'>우리 기관은 원칙적으로 이용자의 동의 없이 해당 개인정보의 처리를 타인에게 위탁하지 않습니다.</li>
                                    </div>
                                    <label className="p_chkbox">
                                        <input type="checkbox" name="agree" value="agree" ref={recCheckboxRef} />
                                        <span className='f_small'>개인정보 수집·이용 동의 (필수)</span>
                                    </label>
                                </div>
                                <div className='recruit_regi_box'>
                                    <div className='recruit_regi_item'>
                                        <span className='rec_regi_tit'>채용공고</span>
                                        <span className='rec_regi_con'>{data.title}</span>
                                    </div>
                                    <div className='recruit_regi_item'>
                                        <span className='rec_regi_tit'>이메일</span>
                                        <div className='rec_regi_conbox'>
                                            <input className='p_ip' type="text" placeholder='회신 가능한 이메일을 입력해주시기 바랍니다.' ref={recEmailRef} />
                                        </div>
                                    </div>
                                    <div className='recruit_regi_item p_i'>
                                        <span className='rec_regi_tit'>이름</span>
                                        <div className='rec_regi_conbox'>
                                            <input className='p_ip' type="text" ref={recNameRef} />
                                        </div>
                                    </div>
                                    <div className='recruit_regi_item p_i'>
                                        <span className='rec_regi_tit'>첨부파일</span>
                                        <div className='rec_regi_conbox'>
                                            <input className='' type="file" ref={recFileRef} />
                                        </div>
                                    </div>
                                    <div className='p_i'>
                                        <div className='p_i_con_box'>
                                            <span className='f_small before_required'>제출이 완료되면 내용을 수정할 수 없습니다.</span>
                                        </div>
                                    </div>
                                    <div className='p_i'>
                                        <div className='p_i_con_box center'>
                                        <button className='p_btn p_btn_normal mgl10' onClick={recHandleSubmit}>제출</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {memberDepartChk && (
                        <>
                            <div className='docu_comment_wrap'>
                                <span className='f_normal docu_comment_count'>댓글 <font className='f_bold'>{commentPack.length}</font></span>
                                {commentPack.length > 0 ? (
                                    <>
                                        
                                        <div className="docu_comment_list">
                                            {commentPack.map((comment) => (
                                                <div key={comment.idx} className="docu_comment_item">
                                                    <span className='f_small f_bold docu_c_i_name'>{comment.memberName} ({comment.organizationKR})</span>
                                                    <span className='f_small docu_c_i_con' dangerouslySetInnerHTML={{ __html: comment.contents.replace(/\n/g, '<br />') }}></span>
                                                    <span className='docu_c_i_reg'>{comment.createTime}</span>
                                                    {comment.my === 'my' && (
                                                        <button className={`p_btn  docu_c_i_del`} onClick={() => gogoCommentDel(comment.idx)} >삭제</button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <div>
                                        {/* 등록된 댓글이 없습니다 */}
                                    </div>
                                )}

                                        
                                {MdCommentWriteStat && (
                                    <div className='docu_comment_write_wrap'>
                                        <span className='f_small docu_comment_write_myname'>{loginName}</span>
                                        <textarea
                                            className='p_txtarea'
                                            placeholder='댓글을 남겨보세요'
                                            ref={taRef}
                                            value={taVal}
                                            onChange={taChange}
                                        ></textarea>
                                        <button className={`p_btn p_btn_grey`} onClick={gogoComment}>등록</button>
                                    </div>
                                )}

                            </div>
                        </>
                    )}
                    
                    
                    {memberDepartChk && (
                        
                        <>
                            <div className='md_foot_right_btn_box'>
                                <button className={`p_btn p_btn_normal p_btn_grey md_foot_btn`} onClick={gogoMdList}>목록</button>
                                {memberDepartEditStat && (
                                    <>
                                        <button className={`p_btn p_btn_normal md_foot_btn`} onClick={gogopage}>수정</button>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </div>

            </div>
            
        </>
    );
}

export default Detail;
